export const getAccessColor = (accessType, rowUser) => {
  if(rowUser && rowUser.builderStatus === 'ADMIN') {
    return '#e6f2ff'; // Lighter blue
  }
  switch (accessType) {
    case 'OWNER':
      return '#cce5ff'; // Light blue
    case 'VIEWER':
      return '#d4edda'; // Light green
    case 'DEMO':
      return '#fffdaf'; // Light yellow
    case 'SALES_DEMO':
      return '#e2d9f3'; // Light purple
    default:
      return '#f8d7da'; // light red
  }
};

export const getReadableAccessLevel = (accessType, rowUser, isMobile) => {
  if(rowUser && rowUser.builderStatus === 'ADMIN') {
    return isMobile ? 'OWNER' : 'BUILDER ADMIN';
  }
  switch (accessType) {
    case 'OWNER':
      return isMobile ? 'ADMIN' : 'CAMERA ADMIN';
    case 'VIEWER':
      return isMobile ? 'FULL' : 'FULL ACCESS';
    case 'DEMO':
      return isMobile ? 'LIVE' : 'LIVE VIEW ONLY';
    case 'SALES_DEMO':
      return isMobile ? 'DEMO' : 'SALES DEMO';
    default:
      return isMobile ? 'NONE' : 'NO ACCESS';
  }
}; 